import { UserContext, UserProfile } from '../Contexts/UserContext';
import { getCurrentAccount } from '../Security/azureAdAuthentication';

// Utility function to format name from "Last, First" to "First Last"
export const formatDisplayName = (name?: string): string => {
    if (!name) return '';
    
    // Check if name contains comma (Last, First format)
    if (name.includes(',')) {
        const [lastName, firstName] = name.split(',').map(part => part.trim());
        return `${firstName} ${lastName}`;
    }
    
    // Return as is if no comma found
    return name;
};

// Utility function to generate initials from "First Last" format
export const generateInitials = (name?: string): string => {
    if (!name) return '';
    
    const formattedName = formatDisplayName(name);
    const nameParts = formattedName.split(' ').filter(part => part.length > 0);
    
    if (nameParts.length >= 2) {
        // Take first letter of first name and first letter of last name
        return `${nameParts[0][0]}${nameParts[nameParts.length - 1][0]}`.toUpperCase();
    } else if (nameParts.length === 1) {
        // If only one name part, take first two letters
        return nameParts[0].substring(0, 2).toUpperCase();
    }
    
    return '';
};

export const getUserInfoDebug = (profile: UserProfile | undefined): string  => {
    if (!profile) {
        const account = getCurrentAccount();
        if (account) {
            return `user: ${account.username || 'unknown'}, ${account.name || 'unknown'} *`;
        }
        return 'user: Not available';
    }
    const username = profile.username || 'unknown';
    const name = profile.name || 'unknown';
    return `user: ${username}, ${name}`;
};
